import { useState } from "react";
import axios from "axios";
import { ArrowRight, FileDown, Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ChecklistGate() {
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [state, setState] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    if (state === "loading") return;
    setState("loading");
    try {
      await axios.post(`${API}/fieldnotes`, { email, website, source: "checklist-six-questions" });
      setState("success");
    } catch {
      setState("error");
    }
  };

  return (
    <div className="border border-glow/30 bg-charcoal/30 p-8 lg:p-10" data-testid="checklist-gate">
      <p className="kicker">The checklist</p>
      <h3 className="mt-4 text-2xl font-medium tracking-tight text-slate-100">
        The six questions, as a branded PDF.
      </h3>
      <p className="mt-3 max-w-lg text-sm leading-relaxed text-slate-400">
        Join the Fieldnotes and take the checklist with you — print it, bring it to your next
        meeting, and mark every step that depends on a specific person.
      </p>
      {state === "success" ? (
        <div className="mt-7 flex flex-col items-start gap-5">
          <p className="flex items-center gap-2.5 text-sm text-slate-200" data-testid="checklist-success-message">
            <Check size={15} className="shrink-0 text-glow" />
            You're in. The checklist is ready.
          </p>
          <p className="text-xs leading-relaxed text-slate-500">
            The checklist also arrives by email — if it doesn't, check your spam folder.
          </p>
          <a
            href="/assets/six-questions-checklist.pdf"
            download
            className="btn-primary"
            data-testid="checklist-download-button"
          >
            <FileDown size={14} /> Download the checklist
          </a>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-7" data-testid="checklist-form">
          <div className="flex flex-col gap-3 sm:flex-row">
            <label htmlFor="cl-email" className="sr-only">
              Email address
            </label>
            <input
              id="cl-email"
              type="email"
              required
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (state === "error") setState("idle");
              }}
              placeholder="you@organisation.co.uk"
              className="field-input flex-1"
              data-testid="checklist-email-input"
            />
            <input
              type="text"
              value={website}
              onChange={(e) => setWebsite(e.target.value)}
              className="hidden"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              name="website"
            />
            <button type="submit" className="btn-primary shrink-0" disabled={state === "loading"} data-testid="checklist-submit-button">
              {state === "loading" ? "Preparing…" : "Get the checklist"}
              <ArrowRight size={14} />
            </button>
          </div>
          {state === "error" && (
            <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.2em] text-red-400" data-testid="checklist-error-message">
              That didn't go through — check the address and try again.
            </p>
          )}
        </form>
      )}
    </div>
  );
}
